export const contactUsPositionList = [
  {
    value: "Chief Information Security Officer (CISO)",
    label: "Chief Information Security Officer (CISO)",
  },
  {
    value: "Chief Executive Officer (CEO)",
    label: "Chief Executive Officer (CEO)",
  },
  {
    value: "Chief Technology Officer (CTO)",
    label: "Chief Technology Officer (CTO)",
  },
  {
    value: "Chief Operating Officer (COO)",
    label: "Chief Operating Officer (COO)",
  },
  {
    value: "Human Resources (HR) Manager",
    label: "Human Resources (HR) Manager",
  },
  {
    value: "Data Protection Officer (DPO)",
    label: "Data Protection Officer (DPO)",
  },
  { value: "IT Manager", label: "IT Manager" },
  { value: "Security Analyst", label: "Security Analyst" },
  { value: "Security Engineer", label: "Security Engineer" },
  { value: "Other", label: "Other" },
];
